import { createElement, useRef } from 'react';
import './index.scss';
const ColorfulCollapse = props => {
    const { defaultIndex, collapsePanes, accordion, ...otherProps } = props;
    const prefixCls = 'au-collapse';
    const containerRef = useRef(null);
    const _otherProps = otherProps || {};
    const handleCollapse = (index) => {
        const contents = containerRef.current.querySelectorAll('.au-collapse-panel-content');
        const content = contents[index];
        const nowH = parseInt(window.getComputedStyle(content).height);
        const inner = content.querySelector('.au-collapse-panel-content-inner');
        const inH = parseInt(window.getComputedStyle(inner).height);
        content.style.height = `${nowH}px`;
        requestAnimationFrame(() => {
            if (content) {
                nowH > 0 ? content.style.height = `${0}px` : content.style.height = `${inH}px`;
            }
        });
        const headers = containerRef.current.querySelectorAll('.au-collapse-anchor');
        const header = headers[index];
        const arrow = header.querySelector('.au-collapse-anchor-arrow');
        nowH > 0 ? arrow.style.transform = 'rotate(180deg)' : arrow.style.transform = 'rotate(0deg)';
        if (accordion) {
            contents?.forEach((item, conIndex) => {
                if (conIndex !== index) {
                    item.style.height = '0px';
                    const arrItem = headers[conIndex];
                    const arr = arrItem.querySelector('.au-collapse-anchor-arrow');
                    arr.style.transform = 'rotate(180deg)';
                }
            });
        }
    };
    return (createElement("div", { className: prefixCls, ref: containerRef, ..._otherProps }, collapsePanes?.map((pane, index) => {
        return (createElement("div", { key: index, className: "au-collapse-item" },
            createElement("a", { className: "au-collapse-anchor au-collapse-panel-header", onClick: () => handleCollapse(index) },
                createElement("div", { className: "au-collapse-anchor-title" }, pane?.title),
                createElement("div", { className: "au-collapse-anchor-arrow" },
                    createElement("icon", { className: "icon-angle-down" }))),
            createElement("div", { className: "au-collapse-panel-content" },
                createElement("div", { className: "au-collapse-panel-content-inner" }, pane?.children))));
    })));
};
ColorfulCollapse.displayName = 'ColorfulCollapse';
export default ColorfulCollapse;
